import { clients } from 'lib/https';
import { ConfigurationSettings } from '/models/configuration-settings';

export interface ISignatureResponse {
  redirectUrl: string | null;
  errorMessage: string | null;
  success: boolean;
}

export const getSignatureResponse = async (
  config: ConfigurationSettings
): Promise<ISignatureResponse> => {
  const baseUrl = `https://${config.paths.baseUrl}`;
  const url = `${baseUrl}${config.paths.bebrave.getRedirectUrl}`;
  return clients.get(url, config.blocksKey);
};
